import { PublicClientApplication } from '@azure/msal-browser';
import appConfig from '../config';

export const msalConfig = {
  auth: {
    clientId: appConfig.azure.clientId,
    authority: appConfig.azure.authority,
    redirectUri: appConfig.azure.redirectUri,
    postLogoutRedirectUri: appConfig.azure.logoutUri,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', 'profile', 'User.Read'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
